export enum HttpCodeStatus {
  OK = 200,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}

// For users specific with expired or suspeded accounts that returns a 403 from the API
export const EXPIRED_OR_SUSPENDED_ACCOUNT_MESSAGE =
  'This account is no longer active either due to its trial expiring or for a billing issue.';
